import React, {Component} from 'react';

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import CONFIG from './../../SYSTEM/Config.js'

import { Request } from "./../../SYSTEM/Request"


function mapStateToProps(state) {
    return {
        OPEN_MARKETING: state.OPEN_MARKETING,
        USER: state.USER
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class MarketingModal extends Component {

    /// CONSTRUCTOR ///
    constructor(props) {
        super(props);
        this.state = {
            SEND_DATA: false
        }
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.OPEN_MARKETING !== prevProps.OPEN_MARKETING) {
            if (window.innerWidth < 1200) {
                if (!this.props.OPEN_MARKETING) {
                    document.body.classList.remove("modal-open");
                    document.documentElement.scrollTop = this.OFFSET;
                } else {
                    this.OFFSET = window.pageYOffset || document.documentElement.scrollTop;
                    document.body.classList.add("modal-open");
                }
            }
        }
    }

    sendRequest = async () => {
        let SEND_DATA = {
            action: 'sendSupplierMarketingRequest',
            supplier_apikey: this.props.USER.supplier_apikey,
            id: this.props.OPEN_MARKETING
        };
        try {
            let data = await Request(SEND_DATA, CONFIG.API_GATE);
            if (data !== false) {
                this.setState({SEND_DATA: true});
            }
        } catch (error) {
        }
    }

    renderContent = () => {
        if (this.props.OPEN_MARKETING) {
            if(this.state.SEND_DATA){
                return (
                    <div className="marketing_modal_holder">
                        <img className="blue_cross" src="/system_images/blue_cross.png" onClick={()=> {this.props.openMarketingModal(false); this.setState({SEND_DATA: false}) }}/>
                        <div className="marketing_modal_text_after_send_blue">Спасибо!</div>
                        <div className="marketing_modal_text_after_send">Заявка отправлена, скоро мы свяжемся с вами!</div>
                    </div>
                )
            }else{
                return (
                    <div className="marketing_modal_holder">
                        <img className="blue_cross" src="/system_images/blue_cross.png" onClick={()=> this.props.openMarketingModal(false)}/>
                        <div className="marketing_modal_text">Если вас интересует этот вариант <br/> сотрудничества, то
                            <span className="marketing_modal_text_blue">оставьте заявку, </span>
                            и наш <br/> менеджер свяжется с вами для уточнения более <br/>
                            подробной информации
                        </div>
                        <div className="marketing_model_blue_button" onClick={() => this.sendRequest()}>Отправить заявку на эту рекламу</div>
                    </div>
                )
            }

        }
    }

    render() {
        if (this.props.OPEN_MARKETING) {
            return (
                <div className="modal">
                    <div className="modal-overlay" onClick={() => this.props.openMarketingModal(false)}>
                    </div>
                    <div className="modal-box">
                        {this.renderContent()}
                    </div>
                </div>
            );
        } else {
            return false;
        }
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(MarketingModal);